
import { Profile } from '@/types/auth';

export function isUserAdmin(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.role === 'admin' || profile.user_type === 'platform_admin';
}

export function isPlatformAdmin(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'platform_admin';
}

export function isOrgAdmin(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'org_admin';
}

export function isTeamMember(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'team_member';
}

export function canManageUsers(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'platform_admin' || profile.user_type === 'org_admin';
}

export function canCreateAssessments(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'platform_admin';
}

export function canManageOrganizations(profile: Profile | null): boolean {
  if (!profile) return false;
  return profile.user_type === 'platform_admin';
}
